module.exports = __webpack_public_path__ + "img/solo act.b4193596.png";